import { memo } from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'

import { CommonLayout } from 'components/Layout'
import { useAppSelector } from 'app/hooks'
import { currentRootDomainIdSelector } from 'features/rootDomains/selectors'
import routes from 'app/routes'
import useScrollToTop from 'app/hooks/useScrollToTop'

import JobsPage from 'features/jobs/JobsPage'
import Home from 'features/home/Home'
import Templates from 'features/templates/Templates'
import Profiles from 'features/profiles/Profiles'
import Licenses from 'features/licenses/Licenses'
import TeamPage from 'features/team/Team'
import Header from 'components/Header'
import Footer from 'components/Footer'
import JobPage from 'features/jobs/JobPage'
import PaymentMethodsPage from 'features/paymentMethods'
import { HomeAudit } from 'features/home/components'
import AddPaymentMethodPage from 'features/paymentMethods/AddPaymentMethodPage'
import CompaniesPage from 'features/domains/CompaniesPage'
import About from 'features/about'
import BillinHistoryPage from 'features/billingHistory'
import MyAccountPage from 'features/auth/myAccount'

import SubscriptionRoute from './SubscriptionRoute'
import NetworkWizard from 'features/networkAi/NetworkWizard'

function AuthorizedRoutes() {
  useScrollToTop()

  const currentRootDomainId = useAppSelector(currentRootDomainIdSelector)

  return (
    <>
      <Header />
      <CommonLayout>
        <Switch>
          <Route path="/:rootDomainId/jobs/:jobId" component={JobPage} />
          <Route path="/:rootDomainId/jobs" component={JobsPage} />
          <Route
            path={`/:rootDomainId${routes.home}/:homeId`}
            component={Home}
          />
          <Route path="/:rootDomainId/templates" component={Templates} />
          <Route path="/:rootDomainId/profiles" component={Profiles} />
          <Route path="/:rootDomainId/licenses" component={Licenses} />
          <Route path="/:rootDomainId/team" component={TeamPage} />
          <Route path="/:rootDomainId/about-company" component={About} />
          <Route path="/:rootDomainId/companies" component={CompaniesPage} />
          <Route path="/:rootDomainId/audit" component={HomeAudit} />
          <Route path="/:rootDomainId/profile" component={MyAccountPage} />
          {/* <Route path="/:" */}

          {/* protected routes for users with "purchase" permission */}
          <SubscriptionRoute path="/:rootDomainId/payment-methods/add">
            <AddPaymentMethodPage />
          </SubscriptionRoute>
          <SubscriptionRoute path="/:rootDomainId/payment-methods">
            <PaymentMethodsPage />
          </SubscriptionRoute>
          <SubscriptionRoute path="/:rootDomainId/billing-history">
            <BillinHistoryPage />
          </SubscriptionRoute>

          <Route path="*">
            <Redirect to={routes.homesJobs(currentRootDomainId)} />
          </Route>
        </Switch>
      </CommonLayout>
      <Footer />
    </>
  )
}

function AuthorizedRoutesWithNetworkAi() {
  return (
    <Switch>
      <Route path={routes.networkAi.wizard.rootNoJob}>
        <NetworkWizard />
      </Route>
      <Route path={routes.networkAi.wizard.root}>
        <NetworkWizard />
      </Route>
      <Route path="*" component={AuthorizedRoutes} />
    </Switch>
  )
}

export default memo(AuthorizedRoutesWithNetworkAi)
